import React, { useEffect } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { GizmoHelper, GizmoViewcube, GizmoViewport } from '@react-three/drei';

const NativeCameraGizmo = ({ viewer, labels }) => {
    const camera = useThree((state) => state.camera);
    const set = useThree((state) => state.set);

    useEffect(() => {
        set({ controls: viewer.controls });
        return () => set({ controls: null });
    }, [set, viewer]);

    // Keep a separate camera so resizing this small overlay never changes the
    // projection/aspect ratio of the converter's native camera.
    useFrame(() => {
        camera.position.copy(viewer.camera.position);
        camera.quaternion.copy(viewer.camera.quaternion);
        camera.up.copy(viewer.camera.up);
        camera.updateMatrixWorld();
    }, -1);

    const updateNativeCamera = () => {
        viewer.camera.position.copy(camera.position);
        viewer.camera.quaternion.copy(camera.quaternion);
        viewer.camera.up.copy(camera.up);
        viewer.controls.update();
        viewer.requestRender();
    };

    return (
        <GizmoHelper alignment="bottom-left" margin={[80, 80]} onUpdate={updateNativeCamera}>
            <GizmoViewcube />
            <GizmoViewport axisColors={['red', 'green', 'blue']} labels={labels} labelColor="black" />
        </GizmoHelper>
    );
};

const HtmlModelGizmo = ({ viewer, labels }) => {
    if (!viewer?.camera || !viewer?.controls) return null;
    return (
        <div style={{ position: 'absolute', left: 0, bottom: 0, width: 160, height: 160 }}>
            <Canvas camera={{ position: [0, 0, 5], fov: 45 }} gl={{ alpha: true }}>
                <NativeCameraGizmo viewer={viewer} labels={labels} />
            </Canvas>
        </div>
    );
};

export default HtmlModelGizmo;
